// extracted by mini-css-extract-plugin
export default {"navLink":"nav-link_navLink__3kNu5","navIcon":"nav-link_navIcon__fzQUk","navLink_active":"nav-link_navLink_active__tKfE1","navLink_disabled":"nav-link_navLink_disabled__+4lb0"};